module.exports = __webpack_public_path__ + "static/consider-phlebas-696d9baa1c896d898c4c9cede3bb77ca.jpg";